// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2770 ? "98f61148" : chunkId) + "." + {"1925":"02fdd7af6f3f3898","2280":"97fb3d309ad2fdbc","2514":"6968ad08d3850e24","2770":"3ce9c248d45b6c84","3362":"fa4cf93e2cd28178","5030":"efa05b8756da2689","7555":"3725ef8d4dac07d3","8859":"046f96e48bcc1d3b"}[chunkId] + ".js";
};